import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import flatMap from 'lodash-es/flatMap';

import { AnalyticsService } from '../../core/analytics.service';
import { TaskService } from '../../shared/task.service';

@Component({
  selector: 'om-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  SECTIONS = [
    { dueRange: 'overdue', label: 'Past Due' },
    { dueRange: 'due', label: 'This week' },
    { dueRange: 'future', label: 'Future' },
  ];

  constructor(public taskService: TaskService, private router: Router, private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.taskService.getTasks();
    this.analyticsService.setModule('All Tasks Page');
    this.taskService.tasks$.subscribe((tasks: any) =>
      this.analyticsService.patientTaskOverviewViewed(flatMap(tasks).length),
    );
  }

  goToTask(id: number) {
    this.router.navigate(['/tasks', id]);
  }
}
